const reportsRoutes = [
  {
    path: '/:prefix(test)?/reports',
    name: 'ReportsList',
    meta: {
      displayNavigationDrawer: true,
      displayOrganization: true,
      parent: 'DocumentsList',
      requireAuth: true,
      requireAccount: true,
      title: 'Reportes'
    },
    component: () => import('@/modules/reports/views/ReportsList')
  }
]
export default reportsRoutes